module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = 1194
// module chunks = 0